export default __webpack_public_path__ + "static/media/arabian-caravan.e1c61fc9.jpg";